import StyledSelect from '../../../../common/StyledSelect';
import { withStyles } from '@material-ui/core';

const styles = (theme) => ({
  root: {
    marginTop: -20,
    minWidth: 150,
    width: '90%'
  },
  label: {
    fontSize: theme.textFontSize,
    transform: `translate(2px, 41px) scale(1)`,
    '&$focusedLabel': {
      transform: `translate(2px, 16px) scale(1)`
    },
    '&$labelShrink': {
      transform: `translate(2px, 20px) scale(1)`
    }
  },
  chip:{
    backgroundColor:theme.palette.primary.main,
    color : theme.white,
    borderRadius: 0,
    fontSize: theme.dispatchCardTextFontSize
  },  
  focusedLabel: { transform: `translate(2px, 6px) scale(1)` },
  labelShrink: {
    transform: `translate(2px, 20px) scale(1)`
  },
  chipIcon: {
    color: theme.white,
    "&:hover": {
      color: theme.white,
    },
  },
  valueContainer:{
    padding:"0px 0px 0px 2px"
  },
  input :{
    padding:"2px 0px",
    marginTop: 16
  }
});

export default withStyles(styles)(StyledSelect);
